/**
 * HELPERS:
 *
 * in Getters:      function_name(state){ return (vars) => ... }
 *
 * in Actions:      function_name(...vars || var || {var1, var2})
 *
 */


import { createPinia, defineStore, acceptHMRUpdate/* , storeToRefs */ } from 'pinia'

// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// const pinia = createPinia()
const store = createPinia()

// store.use(piniaPluginPersistedstate)


// log('in index.js', store)

import { useAppStore }          from './app'
import { useAuthStore }         from './auth'
import { useBusinessStore }     from './business'
import { useCourseStore }       from './course'
import { useColisStore }        from './colis'
import { useDraggableStore }    from './draggable'
import { useEditionStore }      from './edition'
import { useRecipientStore }    from './recipient'
import { useShopStore }         from './shop'
import { useUserStore }         from './user'

import { useCarrierDocStore }   from './carrierdoc'


const appStore          = defineStore('appStore',           useAppStore)
const authStore         = defineStore('authStore',          useAuthStore)
const businessStore     = defineStore('businessStore',      useBusinessStore)
const courseStore       = defineStore('courseStore',        useCourseStore)
const colisStore        = defineStore('colisStore',         useColisStore)
const draggableStore    = defineStore('draggableStore',     useDraggableStore)
const editionStore      = defineStore('editionStore',       useEditionStore)
const recipientStore    = defineStore('recipientStore',     useRecipientStore)
const shopStore         = defineStore('shopStore',          useShopStore)
const userStore         = defineStore('userStore',          useUserStore)

const carrierdocStore   = defineStore('carrierdocStore', useCarrierDocStore)

// manage HMR
const hmr = import.meta.hot
// log('in index.js', hmr)
if (hmr) {
    hmr.accept(acceptHMRUpdate(appStore,            hmr))
    hmr.accept(acceptHMRUpdate(authStore,           hmr))
    hmr.accept(acceptHMRUpdate(businessStore,       hmr))
    hmr.accept(acceptHMRUpdate(courseStore,         hmr))
    hmr.accept(acceptHMRUpdate(colisStore,          hmr))
    hmr.accept(acceptHMRUpdate(draggableStore,      hmr))
    hmr.accept(acceptHMRUpdate(editionStore,        hmr))
    hmr.accept(acceptHMRUpdate(recipientStore,      hmr))
    hmr.accept(acceptHMRUpdate(shopStore,           hmr))
    hmr.accept(acceptHMRUpdate(userStore,           hmr))

    hmr.accept(acceptHMRUpdate(carrierdocStore,     hmr))
}


export {
// return {
    store,

    appStore,
    authStore,
    businessStore,
    courseStore,
    colisStore,
    draggableStore,
    editionStore,
    recipientStore,
    shopStore,
    userStore,

    carrierdocStore
}

// }}

// log(storeConfig)
// export default storeConfig
// export default {
//     appStore: storeConfig.appStore,
// }
